/**
 * SignUpForm - Main entry point
 *
 * Uses the "Documentary Editorial" design aesthetic
 * to match the redesigned landing page.
 */

import SignUpFormRedesign from './SignUpFormRedesign';

export default SignUpFormRedesign;
